import * as API_URL from "../../constants/api";
import * as apiService from "../api";
import { getToken } from "../../helpers/common";

const getCampaigns = async (page, filterData) => {
  try {
    let data = {};

    let token = getToken();

    //if (gstn) {console
    data = { page, filterData };
    console.log("data", data);
    let result = await apiService.post(API_URL.GET_CAMPAIGNS, data, token);
    return result;
    // }
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};

const getCampaign = async (id) => {
  try {
    let token = getToken();

    let result = await apiService.get(API_URL.GET_CAMPAIGN + id, token);
    return result;
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};

const getCreateCampaign = async (payload) => {
  try {
    let data = {};

    let token = getToken();

    //if (gstn) {console
    data = { ...payload };
    console.log("CREATE campaign data #okkkkkkk", data);
    let result = await apiService.post(API_URL.CAMPAIGN_CREATE, data, token);
    return result;
    // }
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};

const getUpdateCampaign = async (payload) => {
  try {
    let data = {};

    let token = getToken();

    //if (gstn) {console
    data = { ...payload };
    console.log("data", data);
    let result = await apiService.put(API_URL.CAMPAIGN_UPDATE, data, token);
    return result;
    // }
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};

const getCampaignRecurrence = async (id) => {
  try {
    let token = getToken();

    let result = await apiService.get(
      API_URL.GET_CAMPAIGN_RECURRENCE + id,
      token
    );
    return result;
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};

const getUpdateCampaignRecurrence = async (payload) => {
  try {
    let data = {};

    let token = getToken();

    //if (gstn) {console
    data = { ...payload };
    console.log("data", data);
    let result = await apiService.put(
      API_URL.CAMPAIGN_RECURRENCE_UPDATE,
      data,
      token
    );
    return result;
    // }
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};

const getCreateCampaignRecurrence = async (payload) => {
  try {
    let data = {};

    let token = getToken();

    //if (gstn) {console
    data = { ...payload };
    console.log("CREATE campaign recurrence data #okkkkkkk", data);
    let result = await apiService.post(
      API_URL.CAMPAIGN_RECURRENCE_CREATE,
      data,
      token
    );
    return result;
    // }
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};
const deleteCampaign = async (payload) => {
  try {
    let data = {};

    let token = getToken();

    //if (gstn) {console
    data = { ...payload };
    console.log("delete campaign #okkkkkkk", data);
    let result = await apiService.post(API_URL.CAMPAIGN_DELETE, data, token);
    return result;
    // }
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};
const cloneCampaign = async (payload) => {
  try {
    let data = {};

    let token = getToken();

    //if (gstn) {console
    data = { ...payload };
    console.log("clone campaign #okkkkkkk", data);
    let result = await apiService.post(API_URL.CAMPAIGN_CLONE, data, token);
    return result;
    // }
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};
const testCampaign = async (payload) => {
  try {
    let data = {};

    let token = getToken();

    //if (gstn) {console
    data = { ...payload };
    console.log("clone campaign #okkkkkkk", data);
    let result = await apiService.post(API_URL.TEST_CAMPAIGN, data, token);
    return result;
    // }
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};

const getCampaignErrors = async (page, filterData) => {
  try {
    let data = {};

    let token = getToken();

    data = { page, filterData };
    console.log("getCampaignErrors service #okkkkkkk", data);
    let result = await apiService.post(API_URL.CAMPAIGN_ERRORS, data, token);
    return result;
    // }
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};
const getCampaignErrorCount = async () => {
  try {
    let data = {};

    let token = getToken();

    data = {};
    console.log("getCampaignErrorCount service #okkkkkkk", data);
    let result = await apiService.post(API_URL.CAMPAIGN_ERROR_COUNT, data, token);
    return result;
    // }
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};


const getTodayCampaigns = async (filterData) => {
  try {
    let data = filterData;
    let token = getToken();
    console.log("data", data);
    let result = await apiService.post(API_URL.GET_TODAY_CAMPAIGNS, data, token);
    return result;
    // }
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
}

const getCampaignLogsDetailsByUuid = async (data) => {
  try {
    const { campaignUuid } = data;
    const token = getToken();
    const result = await apiService.post(`${API_URL.GET_TODAY_CAMPAIGNS}/${campaignUuid}`, data, token);
    return result;
  } catch (err) {
    return { status: false, data: {}, message: err.message || "Error fetching logs" };
  }
}

const getCampaignSuggestions = async (payload) => {
  try {
    const token = getToken();
    const result = await apiService.post(`${API_URL.GET_TODAY_CAMPAIGNS}/suggestions`, payload, token);
    return result;
  } catch (err) {
    return { status: false, data: {}, message: err.message || "Error fetching logs" };
  }
}

const getSnsStatesSummary = async (payload) => {
  try {
    const token = getToken();
    const { campaignUuid } = payload;
    const result = await apiService.get(`${API_URL.EMAIL_CAMPAIGNS}/SNS/stats/${campaignUuid}`, token);
    return result;
  } catch (err) {
    return { status: false, data: {}, message: err.message || "Error fetching data" };
  }
}

const getCampaignStatsByUuid = async (payload) => {
  try {
    const token = getToken();
    const { campaignUuid } = payload;
    const result = await apiService.get(`${API_URL.EMAIL_CAMPAIGNS}/SNS/campaign-stats/${campaignUuid}`, token);
    return result;
  } catch (err) {
    return { status: false, data: {}, message: err.message || "Error fetching data" };
  }
}

// { campaignId, page, limit }
const getCampaignDataIssues = async ({ campaignId, campaignUuid, page = 1, limit = 10, eventType = 'all', }) => {
  try {
    const token = getToken();
    const payload = { eventType };
    const queryParams = new URLSearchParams({ campaignId, campaignUuid, page, limit }).toString();
    const result = await apiService.post(`${API_URL.DATA_ISSUE}?${queryParams}`, payload, token);
    return result;
  } catch (err) {
    return {
      status: false,
      data: {},
      message: err?.message || "Error fetching logs",
    };
  }
};

const getDataIssueSummary = async ({ campaignId, campaignUuid }) => {
  try {
    const token = getToken();

    const result = await apiService.get(`${API_URL.DATA_ISSUE}/summary/${campaignId}/${campaignUuid}`, token);
    return result;
  } catch (err) {
    return {
      status: false,
      data: {},
      message: err?.message || "Error fetching logs",
    };
  }
}

const markCampaignStatus = async (payload) => {
  try {
    const token = getToken();
    const result = await apiService.post(`${API_URL.CAMPAIGN_RUN_REPORT}/updateStatus`, payload, token);
    return result;
  } catch (err) {
    return {
      status: false,
      data: {},
      message: err?.message || "Error fetching logs",
    };
  }
}

const saveCampaignSetting = async (payload) => {
  try {
    const token = getToken();
    const result = await apiService.post(`${API_URL.CAMPAIGN}/saveSetting`, payload, token);
    return result;
  } catch (err) {
    return err?.response?.data || {
      status: false,
      data: {},
      message: err?.message || "Error Updating Setting",
    };
  }
}

const campaignsService = {
  getCampaigns,
  getCampaign,
  getCreateCampaign,
  getUpdateCampaign,
  getCampaignRecurrence,
  getUpdateCampaignRecurrence,
  getCreateCampaignRecurrence,
  deleteCampaign,
  cloneCampaign,
  testCampaign,
  getCampaignErrors,
  getCampaignErrorCount,
  getTodayCampaigns,
  getCampaignLogsDetailsByUuid,
  getCampaignSuggestions,
  getSnsStatesSummary,
  getCampaignStatsByUuid,
  getCampaignDataIssues,
  getDataIssueSummary,
  markCampaignStatus,
  saveCampaignSetting
};



export default campaignsService;
